import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { eq } from 'ember-truth-helpers'
import { not } from 'ember-truth-helpers'
import { applyAttr } from 'teacher-ui-client/modifiers/apply-attr'
import type { BaseOption } from 'teacher-ui-client/progress-handler/utils'

interface Signature {
  Args: {
    selectedOption?: BaseOption
    flatOptions?: BaseOption[]
    groupedOptions?: Record<string, BaseOption[]>
  }
}

export const EditProgressOptions: TOC<Signature> = <template>
  <option value="" selected={{not @selectedOption.optionId}} hidden disabled>
    {{t "manage.manageProgress.bulkActions.editProgress.noChange"}}
  </option>
  {{#each @flatOptions as |progressOption|}}
    <option
      value={{progressOption.optionId}}
      selected={{eq progressOption.optionId @selectedOption.optionId}}
      {{applyAttr selected=(eq progressOption.optionId @selectedOption.optionId)}}
    >
      {{progressOption.label}}
    </option>
  {{/each}}
  {{#each-in @groupedOptions as |groupName progressOptions|}}
    {{#if groupName}}
      <optgroup label={{groupName}}>
        {{#each progressOptions as |progressOption|}}
          <option
            value={{progressOption.optionId}}
            selected={{eq progressOption.optionId @selectedOption.optionId}}
            {{applyAttr selected=(eq progressOption.optionId @selectedOption.optionId)}}
          >
            {{progressOption.label}}
          </option>
        {{/each}}
      </optgroup>
    {{else}}
      {{#each progressOptions as |progressOption|}}
        <option
          value={{progressOption.optionId}}
          selected={{eq progressOption.optionId @selectedOption.optionId}}
          {{applyAttr selected=(eq progressOption.optionId @selectedOption.optionId)}}
        >
          {{progressOption.label}}
        </option>
      {{/each}}
    {{/if}}
  {{/each-in}}
</template>

export default EditProgressOptions
